import React from "react";

export const Danger = ({ message }) => (
  <div className="alert">
    <p>{message}</p>
  </div>
);
